<template>
  <v-app>
    <v-main style="background-color: #ededed;">
      <router-view />
      <!-- Birthday Notification Dialog -->
      <v-dialog
        v-model="showBirthdayDialog"
        max-width="400"
        persistent
        transition="dialog-bottom-transition"
      >
        <v-card class="pa-4" style="border-radius: 12px; box-shadow: 0 4px 20px rgba(0,0,0,0.1);">
          <v-card-title style="font-family: MSemiBold">
            🎉 Today's Birthdays!
          </v-card-title>
          <v-card-text>
            <v-list v-if="birthdays.length > 0" dense>
              <v-list-item v-for="(person, index) in birthdays" :key="index">
                <v-list-item-content>
                  <v-list-item-title style="font-family: MSemiBold">
                    <span style="font-family: MSemiBold;text-transform: uppercase;">{{ index + 1 }}. {{ person.ml_name }} </span>
                    <span v-if="person.ml_baptismName">({{ person.ml_baptismName }})</span>
                  </v-list-item-title>
                  <v-list-item-subtitle style="font-family: MSemiBold">
                    Unit: {{ person.unit.ml_unitName }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle style="font-family: MSemiBold">
                    Family ID: {{ person.family.familyID }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <p v-else class="text-center grey--text">
              No birthdays today.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="closeBirthdayDialog"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
    <AppFooter v-if="$route.name != 'login'" />
  </v-app>
</template>

<script>
import "./assets/style/font.css";
import "./assets/style/style.css";
import store from "./store";
import axios from "axios";
import AppFooter from "./components/Common/appFooter";

export default {
  components: {
    AppFooter,
  },
  name: 'App',
  data: () => ({
    showBirthdayDialog: false,
    birthdays: [],
  }),
  watch: {
    // Watch for changes in isLoggedIn state
    '$store.state.isLoggedIn': {
      handler(newValue) {
        if (newValue) {
          // User just logged in, fetch birthdays
          this.getTodayBirthdays();
        }
      },
      immediate: false // Do not trigger on component creation unless isLoggedIn changes
    }
  },
  beforeMount() {
    this.getData();
    // Only call getTodayBirthdays if already logged in
    if (this.$store.state.isLoggedIn) {
      this.getTodayBirthdays();
    }
  },
  methods: {
    getData() {
      axios({
        method: "GET",
        url: "/admin/profile",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            store.commit("userData", response.data.data);
            store.commit("userType", response.data.userdata.role);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTodayBirthdays() {
      // Check if birthday notification was already closed in this session
      const hasClosedBirthdays = localStorage.getItem("hasClosedBirthdays");
      if (hasClosedBirthdays) return;

      axios({
        method: "GET",
        url: "/admin/members/birthdays/today",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status && response.data.data?.length > 0) {
            this.birthdays = response.data.data; // Store the array of birthday objects
            this.showBirthdayDialog = true;
          }
          // Do not show dialog if no data or status is false
        })
        .catch((err) => {
          console.log("Error fetching birthdays:", err);
        });
    },
    closeBirthdayDialog() {
      this.showBirthdayDialog = false;
      // Mark as closed in localStorage to prevent re-display
      localStorage.setItem("hasClosedBirthdays", "true");
    },
  },
};
</script>

<style scoped>
/* Ensure the dialog has a clean, notification-like appearance */
.v-dialog {
  border-radius: 12px !important;
  overflow: hidden;
}
/* Styling for the list items */
.v-list-item-title {
  color: #333;
}
.v-list-item-subtitle {
  color: #666;
}
</style>